import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IOnlineRiskManagementFormMeta {
  periodicity: FormInputMeta;
  name: FormInputMeta;
  exceptionalCeilingFrom: FormInputMeta;
  exceptionalCeilingTo: FormInputMeta;

  schema: any;
}

const onlineRiskManagementFormMeta = {} as IOnlineRiskManagementFormMeta;

onlineRiskManagementFormMeta.periodicity = {
  name: "periodicity",
  type: "select",
  label: "Périodicité",
  placeholder: "",
  validation: yup.string(),
};

onlineRiskManagementFormMeta.name = {
  name: "name",
  type: "text",
  label: "Nom",
  placeholder: "",
  validation: yup.string(),
};

onlineRiskManagementFormMeta.exceptionalCeilingFrom = {
  name: "exceptionalCeilingFrom",
  type: "text",
  label: "Plafond Exceptionnel De:",
  placeholder: "",
  validation: yup.string(),
};

onlineRiskManagementFormMeta.exceptionalCeilingTo = {
  name: "exceptionalCeilingTo",
  type: "text",
  label: "à",
  placeholder: "",
  validation: yup.string(),
};


onlineRiskManagementFormMeta.schema = yup.object().shape(getValidationSchema(onlineRiskManagementFormMeta));

export default onlineRiskManagementFormMeta;